import React, { useEffect, useState, useRef } from "react";
import { IonPage } from "@ionic/react";
import { Layout } from "antd";
import { useLocation } from "react-router-dom"; // Import useLocation to track pathname changes

import Sider from "./Sider";
import Header from "./Header";

const { Content } = Layout;

const ApproverLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const contentRef = useRef(null); // Create a ref for the Content
  const location = useLocation(); // Get the current location

  // Function to scroll to the top
  const scrollToTop = () => {
    if (contentRef.current) {
      contentRef.current.scrollTo({ top: 0 });
    }
  };

  // Effect to scroll to top on pathname change
  useEffect(() => {
    scrollToTop();
  }, [location.pathname]); // Trigger effect when pathname changes

  return (
    <IonPage>
      <Layout hasSider style={{ minHeight: "100vh" }}>
        <Sider collapsed={collapsed} onCollapse={setCollapsed} />
        <Layout style={{ marginLeft: collapsed ? 80 : 200 }}>
          <Header />
          <Content
            ref={contentRef} // Attach the ref to the Content
            style={{
              background: "white",
              margin: 0,
              padding: "0 2rem",
              overflowY: "auto",
              height: "calc(100vh - 64px)",
            }}
          >
            {children} {/* Page specific content goes here */}
          </Content>
        </Layout>
      </Layout>
    </IonPage>
  );
};

export default ApproverLayout;
